import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { FadeIn } from "@/components/FadeIn";
import { useNativeCarousel } from "@/lib/useCarousel";
import { workGlimpse } from "@/data/workGlimpse";

const GAP = 24;

export function WorkGlimpseSection() {
  const { ref, itemsPerView, canPrev, canNext, prev, next } = useNativeCarousel();

  return (
    <section data-testid="work-glimpse-section" className="py-28 md:py-36 bg-black border-t border-white/10">
      <div className="container-custom">
        <FadeIn className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 mb-10">
          <div className="max-w-sm order-2 md:order-1">
            <p className="text-sm md:text-base text-zinc-400 leading-relaxed mb-6">
              We connect strategy, creativity, technology and AI to build systems that attract customers and scale your business.
            </p>
            <Link
              to="/work"
              data-testid="work-glimpse-see-more-link"
              className="inline-flex items-center gap-2 bg-violet-500 text-white text-xs font-bold tracking-widest uppercase px-7 py-4 rounded-full hover:bg-violet-400 transition-colors duration-300"
            >
              See More
            </Link>
          </div>

          <h2 className="order-1 md:order-2 font-display font-bold text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-white text-left md:text-right">
            A GLIMPSE AT
            <br />
            OUR WORK
          </h2>
        </FadeIn>

        <div className="flex items-center justify-end gap-3 mb-6">
          <button
            onClick={prev}
            disabled={!canPrev}
            data-testid="work-glimpse-prev-btn"
            aria-label="Previous"
            className={`w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white transition-colors duration-300 ${
              canPrev ? "hover:bg-white/10 hover:border-violet-400" : "opacity-30 cursor-not-allowed"
            }`}
          >
            <ArrowLeft size={16} />
          </button>
          <button
            onClick={next}
            disabled={!canNext}
            data-testid="work-glimpse-next-btn"
            aria-label="Next"
            className={`w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white transition-colors duration-300 ${
              canNext ? "hover:bg-white/10 hover:border-violet-400" : "opacity-30 cursor-not-allowed"
            }`}
          >
            <ArrowRight size={16} />
          </button>
        </div>

        <div
          ref={ref}
          data-testid="work-glimpse-track-viewport"
          className="flex overflow-x-auto no-scrollbar snap-x snap-mandatory scroll-smooth"
          style={{ gap: `${GAP}px` }}
        >
          {workGlimpse.map((item, i) => (
            <div
              key={item.caption}
              className="shrink-0 snap-start"
              style={{ width: `calc((100% - ${GAP * (itemsPerView - 1)}px) / ${itemsPerView})` }}
            >
              <div className="overflow-hidden">
                <img
                  src={item.image}
                  alt={item.caption}
                  data-testid={`work-glimpse-image-${i}`}
                  className={`w-full object-cover hover:scale-105 transition-transform duration-500 ${item.heightClass}`}
                />
              </div>
              <p className="mt-4 text-sm text-zinc-400" data-testid={`work-glimpse-caption-${i}`}>
                {item.caption}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
